import { Stop, QuoteStop, StopForUpdateComplete } from './quoteStop';

export class FtlQuote {
  mode: string = 'FTL';
  commodity: string;
  completedBy: string;
  completedByEmail: string;
  completedOn: string;
  createdBy: number;
  createdByEmail: string;
  createdOn: string;
  customerId: number;
  customerPO: string;
  distance: number;
  expirationDate: string;
  id: number;
  isHazmat: boolean;
  loadValueCode: string;
  pickupDate: string;
  rate: number;
  rateBookedBy: string;
  rateBookedByEmail: string;
  rateBookedOn: string;
  rateIssuedBy: string;
  rateIssuedOn: string;
  specialInstructions: string;
  status: string;
  stops: Stop[] = [];
  temperature: number;
  tenderedBy: string;
  tenderedByEmail: string;
  tenderedOn: string;
  totalWeight: number;
  trailerSize: string;
  trailerType: string;
  transitDays: number;
  updatedBy: string;
  updatedByEmail: string;
  updatedOn: string;
  requestedRate: number;
  blNumber: string;

  constructor() {}

}

export class FtlQuoteForCreate {
  trailerType: string;
  temperature: number;
  commodity: string;
  isHazmat: boolean;
  loadValueCode: string;
  stops: QuoteStop[];
  totalWeight: number;

  constructor(formQuoteValues: any) {
    this.trailerType = formQuoteValues.loadDetailsBasic.trailerType.code;
    this.temperature = parseInt(formQuoteValues.loadDetailsBasic.temperature);
    this.commodity = formQuoteValues.loadDetailsBasic.commodity;
    this.isHazmat = formQuoteValues.loadDetailsBasic.hazmat;
    this.loadValueCode = formQuoteValues.loadDetailsBasic.value.code;
    this.totalWeight = formQuoteValues.loadDetailsBasic.weight;

    this.stops = [];
    if (formQuoteValues.loadDetailsRoute.stops) {
      formQuoteValues.loadDetailsRoute.stops.forEach(
        (stop, i) => {this.stops.push(new QuoteStop(stop.stopType, stop.stopDate , stop, i+1));}
      );
    }
  }
}

export class FtlQuoteForUpdateComplete {
  customerPO: string;
  trailerSize: string;
  totalWeight: number;
  specialInstructions: string;
  requestedRate: number;
  blNumber: string;
  stops: StopForUpdateComplete[];
  isGetQuote: boolean;

  constructor(quoteForUpdateFormValue: any) {
    this.customerPO = quoteForUpdateFormValue.additionalLoadDetails.customerPO;
    this.specialInstructions = quoteForUpdateFormValue.additionalLoadDetails.specialInstructions;
    this.trailerSize = quoteForUpdateFormValue.additionalLoadDetails.trailerSize;
    this.totalWeight = quoteForUpdateFormValue.additionalLoadDetails.weight;
    this.requestedRate = quoteForUpdateFormValue.additionalLoadDetails.requestedRate;
    this.blNumber = quoteForUpdateFormValue.additionalLoadDetails.blNumber;
    
    if (this.blNumber && this.blNumber.length > 0) {
      var tmpSI: string = this.specialInstructions ? this.specialInstructions : '';
      if (this.specialInstructions) {
        var blIndex = this.specialInstructions.indexOf(' BL#: ');
        if (blIndex > -1) {
          var tmpSI = this.specialInstructions.substring(0, blIndex);
        }
      }
      this.specialInstructions = tmpSI + ' BL#: ' + this.blNumber;
    }

    this.stops = quoteForUpdateFormValue.additionalRouteDetails.stops;
    // this.stops = [];
    // if (quoteForUpdateFormValue.additionalRouteDetails.stops) {
    //   // quoteForUpdateFormValue.additionalRouteDetails.stops.forEach(
    //   //   stops => this.stops.push
    //   // );
    // }
  }
}

export class FtlQuoteCharge {
  detail: string;
  charge: number;
}

